import state from './moduleAnimationState'
import mutations from './moduleAnimationMutations'
import actions from './moduleAnimationActions'
import getters from './moduleAnimationGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
